export default function Menu() {
	// Find the mobile menu trigger, mobile menu, and mobile item triggers
	const mobileMenuTrigger = document.querySelector('.js-mobile-menu-trigger');
	const mobileMenu = document.querySelector('.js-mobile-menu');
	const mobileItemTriggers = document.querySelectorAll('.js-mobile-item-trigger');

	// Toggle the mobile menu
	if (mobileMenuTrigger) {
		mobileMenuTrigger.addEventListener('click', debounce(() => {
			if (mobileMenu) {
				const isActive = mobileMenu.classList.contains('active');
				mobileMenu.classList.toggle('active');

				if (isActive) {
					closeAllItems();
				}
			}

			const text = mobileMenuTrigger.querySelector('.e-btn__text');
			if (text) {
				if (text.innerHTML == 'Menu') {
					text.innerHTML = 'Close';
				} else {
					text.innerHTML = 'Menu';
				}
			}
		}, 150));
	}

	mobileItemTriggers.forEach(trigger => {
		trigger.addEventListener('click', debounce(() => {
			trigger.classList.toggle('active');
			const nextElement = trigger.nextElementSibling;
			if (nextElement) {
				nextElement.classList.toggle('active');
			}
		}, 150));
	});

	if (window.innerWidth >= 1024 && typeof closeMenu === "function") {
		closeMenu();
	}

	window.addEventListener('resize', debounce(() => {
		if (window.innerWidth >= 1024 && typeof closeMenu === "function") {
			closeMenu();
		}
	}, 150));

	function closeMenu() {
		if (mobileMenu) {
			mobileMenu.classList.remove('active');
		}

		const icon = mobileMenuTrigger ? mobileMenuTrigger.querySelector('ion-icon') : null;
		if (icon) {
			icon.setAttribute('name', 'menu-sharp');
		}

		closeAllItems();
	}

	function closeAllItems() {
		mobileItemTriggers.forEach(trigger => {
			trigger.classList.remove('active');
			const nextElement = trigger.nextElementSibling;
			if (nextElement) {
				nextElement.classList.remove('active');
			}
		});
	}

	// Debounce function: Executes the given function after waiting for the specified delay.
	function debounce(func, wait) {
		let timeoutId = null;

		return function () {
			if (timeoutId !== null) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(() => {
				func();
				timeoutId = null;
			}, wait);
		};
	}


	
	const subMenus = document.querySelectorAll('.c-menu__children');

	if (subMenus.length) {
		subMenus.forEach(menu => {
			// Set vars
			const imageWrapper = menu.querySelector('.js-menu-image');
			const slides = menu.querySelectorAll('.js-menu-slide');

			// Check for image and slides
			if (imageWrapper && slides.length) {	
				slides.forEach(slide => {
					slide.addEventListener('mouseenter', () => {
						if (slide.dataset.image) {
							let image = imageWrapper.querySelector('img');
							let imageSrc = slide.dataset.image;
							if (!image.src.includes(imageSrc)) {
								// Delete any rouge instances of images
								let allImages = imageWrapper.querySelectorAll('img');
								let length = allImages.length;
	
								allImages.forEach((element, key) => {
									if (key + 1 == length) {
										element.classList.remove('u-cover');
										element.style.opacity = 1;
									} else {	
										element.remove();
									}
								});

								// Clone our image to smoothly transition
								let clone = image.cloneNode(true);
								clone.classList.add('u-cover');
								clone.src = imageSrc;
								clone.style.opacity = 0;
								image.style.opacity = 0;
								image.after(clone);

								setTimeout(() => {
									clone.style.opacity = 1;
								}, 10);
								
								setTimeout(() => {
									clone.classList.remove('u-cover');
									image.remove();
									image = clone;
								}, 500);
							}
						}
					});
				})
			}
		});
	}
}
